const hostUrl = '/' // 腾讯云
const goodsId = '/servicemart/shop/goodsdetail?goodsId='
const belongStoreId = '&belongStoreId='

const storeUrl = 'servicemart/shop/shopDetailC?storeId='
const storeUrl1 = 'servicemart/shop/shopDetailB?storeId='
const storeUrl2 = 'servicemart/shop/shopDetailC?storeId='
// 获取商品详情路径
export function getGoodsUrl(key1, key2) {
  return hostUrl + goodsId + key1 + belongStoreId + key2
}
// 获取店铺详情路径
export function getStoresUrl(key) {
  return hostUrl + storeUrl + key
}
export function getStoresUrl1(key) {
  return hostUrl + storeUrl1 + key
}
export function getStoresUrl2(key) {
  return hostUrl + storeUrl2 + key
}

// 获取附件路径
export function getFilePath(key) {
  // return 'https://' + bucket + '-' + appId + '.cos.' + region + '.myqcloud.com/' + key
  if(!key||key.startsWith('http'))
    return key
  else
    return "/jkoss/ccjk/" + key
}

// 获取附件名称
export function getFileName(key) {
  if (key !== null && key !== '') {
    // 基于0开始,找不到返回-1
    var keyIndex = key.indexOf('-')
    if (keyIndex !== -1) {
      // 总key长度
      var myStrLength = key.length;
      // 截取附件名称
      key = key.substring(keyIndex + 1, myStrLength);
    }
  }
  return key
}
